module.exports = __webpack_public_path__ + "img/21.dbab5aca.jpg";